import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PricingProvider } from './context/PricingContext';
import { ThemeProvider } from './context/ThemeContext';
import AppLayout from './components/layout/AppLayout';
import ProtectedRoute from './components/layout/ProtectedRoute';
import Loader from './components/ui/Loader';
import InfoPage from './components/InfoPage';
import HelpPage from './components/HelpPage';
import PrivacyPage from './components/PrivacyPage';
import TermsPage from './components/TermsPage';
import LinksPageRoute from './components/layout/LinksPageRoute';
import LoginPage from './components/LoginPage';
import SubscriptionsPage from './components/SubscriptionsPage';
import AccountPage from './components/AccountPage';
import NotFoundPage from './components/NotFoundPage';
import CookieBanner from './components/CookieBanner';
import AnalyticsRouteTracker from './components/AnalyticsRouteTracker';
import SiteStatusGate from './components/SiteStatusGate';
import './App.scss';

function HomeRedirect() {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <AppLayout showHeader={false} bare>
                <Loader text="Проверяем сессию..." />
            </AppLayout>
        );
    }

    return <Navigate to={isAuthenticated ? '/subscriptions' : '/login'} replace />;
}

function ProtectedLayout({ children }) {
    return (
        <ProtectedRoute>
            <AppLayout showTopNav showBottomNav withNavPadding>
                {children}
            </AppLayout>
        </ProtectedRoute>
    );
}

function AppRoutes() {
    return (
        <>
            <AnalyticsRouteTracker />
            <CookieBanner />
            <Routes>
                <Route
                    path="/login"
                    element={
                        <AppLayout showHeader={false} bare>
                            <LoginPage />
                        </AppLayout>
                    }
                />

                <Route path="/" element={<HomeRedirect />} />

                <Route
                    path="/subscriptions"
                    element={
                        <ProtectedLayout>
                            <SubscriptionsPage />
                        </ProtectedLayout>
                    }
                />

                <Route
                    path="/account"
                    element={
                        <ProtectedLayout>
                            <AccountPage />
                        </ProtectedLayout>
                    }
                />

                <Route
                    path="/help"
                    element={
                        <AppLayout showHeader={false} bare showFooter={false}>
                            <HelpPage />
                        </AppLayout>
                    }
                />

                <Route
                    path="/info"
                    element={
                        <AppLayout showHeader={false} bare>
                            <InfoPage />
                        </AppLayout>
                    }
                />

                <Route
                    path="/privacy"
                    element={
                        <AppLayout showHeader={false} bare>
                            <PrivacyPage />
                        </AppLayout>
                    }
                />

                <Route
                    path="/terms"
                    element={
                        <AppLayout showHeader={false} bare>
                            <TermsPage />
                        </AppLayout>
                    }
                />

                <Route path="/links" element={<LinksPageRoute />} />

                <Route path="/successfulpayment" element={<HomeRedirect />} />

                <Route
                    path="/404"
                    element={
                        <AppLayout showHeader={false} bare>
                            <NotFoundPage />
                        </AppLayout>
                    }
                />

                <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
        </>
    );
}

export default function App() {
    return (
        <ThemeProvider>
            <SiteStatusGate>
                <AuthProvider>
                    <PricingProvider>
                        <BrowserRouter>
                            <AppRoutes />
                        </BrowserRouter>
                    </PricingProvider>
                </AuthProvider>
            </SiteStatusGate>
        </ThemeProvider>
    );
}
